module.exports = __webpack_public_path__ + "static/media/widget4-img.1fe0a07d.jpg";